import { Auth } from "aws-amplify";

/**
 * APIをまとめたクラス
 */
class APIClass {
  public urlSensor = process.env.REACT_APP_URL_SENSORS ?? "";
  public urlPico3 = process.env.REACT_APP_URL_PICO3 ?? "";
  public urlBuildings = process.env.REACT_APP_URL_BUILDINGS ?? "";

  public async RegisterBuilding(
    BuildingName: string,
    PolicyNumber: string,
    BuildingAddress: string,
    image: string,
    imageExtension: string
  ) {
    const session = await Auth.currentSession();
    const token = session.getIdToken().getJwtToken();
    const user = await Auth.currentUserInfo();

    let body: string[] = [];
    body.push(`"UserId":"${user.attributes.email}"`);
    if (BuildingName !== "") {
      body.push(`"BuildingName":"${BuildingName}"`);
    }
    if (PolicyNumber !== "") {
      body.push(`"PolicyNumber":"${PolicyNumber}"`);
    }
    if (BuildingAddress !== "") {
      body.push(`"BuildingAddress":"${BuildingAddress}"`);
    }
    if (image !== "") {
      body.push(`"BuildingImage":"${image}"`);
    }
    if (imageExtension !== "") {
      body.push(`"BuildingImageExtension":"${imageExtension}"`);
    }
    if (body.length === 1) {
      return;
    }

    const options: RequestInit = {
      method: "POST",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: token,
      }),
      body: `{${body.join(",")}}`,
    };
    let ok = true;
    await fetch(API.urlBuildings, options)
      .then((response) => {
        ok = response.ok;
        return response.text();
      })
      .then((text: string) => {
        if (ok) {
          return;
        }
        if (0 <= text.toLowerCase().indexOf("already exists")) {
          // エラーメッセージが変更されたら対応が必要
          throw new Error("すでに存在");
        }
        throw new Error("建物情報登録失敗");
      });
  }

  public async GetBuildings() {
    const session = await Auth.currentSession();
    const token = session.getIdToken().getJwtToken();
    const options: RequestInit = {
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: token,
      }),
    };
    let buildings: any = null;
    await fetch(`${this.urlBuildings}`, options)
      .then((response) => {
        if (!response.ok) {
          throw new Error("送信先情報取得失敗");
        }
        return response.json();
      })
      .then((data) => {
        buildings = data;
      });
    return buildings;
  }

  public async EditBuilding(BuildingId: string, body: string) {
    const session = await Auth.currentSession();
    const token = session.getIdToken().getJwtToken();
    const options: RequestInit = {
      method: "PUT",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: token,
      }),
      body: body,
    };
    await fetch(`${API.urlBuildings}/${BuildingId}`, options).then(
      (response) => {
        if (!response.ok) {
          throw new Error("建物情報編集失敗");
        }
      }
    );
  }

  public async DeleteBuilding(BuildingId: string) {
    const session = await Auth.currentSession();
    const token = session.getIdToken().getJwtToken();
    const options: RequestInit = {
      method: "DELETE",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: token,
      }),
    };
    await fetch(`${API.urlBuildings}/${BuildingId}`, options).then(
      (response) => {
        if (!response.ok) {
          throw new Error("建物情報削除失敗");
        }
      }
    );
  }

  public async RegisterPico3(body: string) {
    const session = await Auth.currentSession();
    const token = session.getIdToken().getJwtToken();
    const options: RequestInit = {
      method: "POST",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: token,
      }),
      body: body,
    };
    let ok = true;
    await fetch(API.urlPico3, options)
      .then((response) => {
        ok = response.ok;
        return response.text();
      })
      .then((text: string) => {
        if (ok) {
          return;
        }
        if (0 <= text.toLowerCase().indexOf("already exists")) {
          // エラーメッセージが変更されたら対応が必要
          throw new Error("すでに存在");
        }
        throw new Error("Pico3登録失敗");
      });
  }

  public async GetPico3() {
    const session = await Auth.currentSession();
    const token = session.getIdToken().getJwtToken();
    const options: RequestInit = {
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: token,
      }),
    };
    let pico3: any = null;
    await fetch(API.urlPico3 + "/info", options)
      .then((response) => {
        if (!response.ok) {
          throw new Error("PICO3情報取得失敗");
        }
        return response.json();
      })
      .then((data) => {
        pico3 = data;
      });
    //console.log({pico3})
    return pico3;
  }

  public async EditPico3(PicoId: string, body: string) {
    const session = await Auth.currentSession();
    const token = session.getIdToken().getJwtToken();
    const options: RequestInit = {
      method: "PUT",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: token,
      }),
      body: body,
    };
    await fetch(`${API.urlPico3}/${PicoId}`, options).then((response) => {
      if (!response.ok) {
        throw new Error("PICO3情報編集失敗");
      }
    });
  }

  public async DeletePico3(PicoId: string) {
    const session = await Auth.currentSession();
    const token = session.getIdToken().getJwtToken();
    const options: RequestInit = {
      method: "DELETE",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: token,
      }),
    };
    await fetch(`${API.urlPico3}/${PicoId}`, options).then((response) => {
      if (!response.ok) {
        throw new Error("PICO3情報削除失敗");
      }
    });
  }

  public async RegisterSensor(body: string) {
    const session = await Auth.currentSession();
    const token = session.getIdToken().getJwtToken();
    const options: RequestInit = {
      method: "POST",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: token,
      }),
      body: body,
    };
    let ok = true;
    await fetch(API.urlSensor, options)
      .then((response) => {
        ok = response.ok;
        return response.text();
      })
      .then((text: string) => {
        if (ok) {
          return;
        }
        if (text.toLowerCase().includes("already exists")) {
          // エラーメッセージが変更されたら対応が必要
          throw new Error("すでに存在");
        } else if (text.includes("The specified Soracom SIM does not exist")) {
          throw new Error("SIMが存在しない");
        } else if (
          text.includes(
            "The calculated checksum differs from the expected checksum provided in the SensorId."
          )
        ) {
          throw new Error("チェックサム不正");
        } else if (
          text.includes("Exception: Failed to get SIM expiration time.")
        ) {
          throw new Error("SIM有効期限未設定");
        }
        throw new Error("みはり番登録失敗");
      });
  }

  public async GetSensors() {
    const session = await Auth.currentSession();
    const token = session.getIdToken().getJwtToken();
    const options: RequestInit = {
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: token,
      }),
    };
    let sensors: any = null;
    await fetch(API.urlSensor + "/info", options)
      .then((response) => {
        if (!response.ok) {
          throw new Error("センサ情報取得失敗");
        }
        return response.json();
      })
      .then((data) => {
        sensors = data;
      });
    //console.log({sensors})
    return sensors;
  }

  public async EditSensor(SensorId: string, body: string) {
    const session = await Auth.currentSession();
    const token = session.getIdToken().getJwtToken();
    const options: RequestInit = {
      method: "PUT",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: token,
      }),
      body: body,
    };
    await fetch(`${API.urlSensor}/${SensorId}`, options).then((response) => {
      if (!response.ok) {
        throw new Error("センサ情報編集失敗");
      }
    });
  }

  public async DeleteSensor(SensorId: string) {
    const session = await Auth.currentSession();
    const token = session.getIdToken().getJwtToken();
    const options: RequestInit = {
      method: "DELETE",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: token,
      }),
    };
    await fetch(`${API.urlSensor}/${SensorId}`, options).then((response) => {
      if (!response.ok) {
        throw new Error("センサ情報削除失敗");
      }
    });
  }

  public async GetBuildingPico3Sensors() {
    const session = await Auth.currentSession();
    const token = session.getIdToken().getJwtToken();

    const oBuilding: RequestInit = {
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: token,
      }),
    };
    let buildings: any = null;
    const pBuilding = fetch(`${this.urlBuildings}`, oBuilding)
      .then((response) => {
        if (!response.ok) {
          throw new Error("送信先情報取得失敗");
        }
        return response.json();
      })
      .then((data) => {
        buildings = data;
      });

    const oPico3: RequestInit = {
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: token,
      }),
    };
    let pico3: any = null;
    const pPico3 = fetch(API.urlPico3 + "/info", oPico3)
      .then((response) => {
        if (!response.ok) {
          throw new Error("PICO3情報取得失敗");
        }
        return response.json();
      })
      .then((data) => {
        pico3 = data;
      });

    const oSensors: RequestInit = {
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: token,
      }),
    };
    let sensors: any = null;
    const pSensors = fetch(API.urlSensor + "/info", oSensors)
      .then((response) => {
        if (!response.ok) {
          throw new Error("センサ情報取得失敗");
        }
        return response.json();
      })
      .then((data) => {
        sensors = data;
      });

    await Promise.all([pBuilding, pPico3, pSensors]);
    //console.log({ buildings, pico3, sensors })
    return { buildings, pico3, sensors };
  }
}

const API = new APIClass();
export default API;
